import { createAction, props } from '@ngrx/store';
import { CreateRequisitionRequest } from '../../../../api/gse/models/create-requisition-request';
import { CreateReplenishmentRequest } from '../../../../api/gse/models/create-replenishment-request';
import { ProcurementResponse } from '../../../../api/gse/models/procurement-response';
import { GetProcurementsResponse } from '../../../../api/gse/models/get-procurements-response';
import { GetProcurements$Params } from '../../../../api/gse/functions';

export const createRequisition = createAction(
  '[Procurement] Create Requisition',
  props<{ body: CreateRequisitionRequest }>()
);

export const createRequisitionSuccess = createAction(
  '[Procurement] Create Requisition Success',
  props<{ response: ProcurementResponse }>()
);

export const createRequisitionFailure = createAction(
  '[Procurement] Create Requisition Failure',
  props<{ error: string }>()
);

export const createReplenishment = createAction(
  '[Procurement] Create Replenishment',
  props<{ id: number; body: CreateReplenishmentRequest }>()
);

export const createReplenishmentSuccess = createAction(
  '[Procurement] Create Replenishment Success',
  props<{ response: ProcurementResponse }>()
);

export const createReplenishmentFailure = createAction(
  '[Procurement] Create Replenishment Failure',
  props<{ error: string }>()
);

export const loadProcurements = createAction(
  '[Procurement] Load Procurements',
  props<{ params?: GetProcurements$Params }>()
);

export const loadProcurementsSuccess = createAction(
  '[Procurement] Load Procurements Success',
  props<{ response: GetProcurementsResponse }>()
);

export const loadProcurementsFailure = createAction(
  '[Procurement] Load Procurements Failure',
  props<{ error: string }>()
);
